export default "__VITE_ASSET__UmJZCY8c__"